/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M8 12H16"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14.5 5H15V5C18.866 5 22 8.13401 22 12V12C22 15.866 18.866 19 15 19V19H14.5M9.5 5H9V5C5.13401 5 2 8.13401 2 12V12C2 15.866 5.13401 19 9 19V19H9.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				d="M14.5 5H15V5C18.866 5 22 8.13401 22 12V12C22 15.866 18.866 19 15 19V19H14.5M9.5 5H9V5C5.13401 5 2 8.13401 2 12V12C2 15.866 5.13401 19 9 19V19H9.5M8 12H16"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M14.5 5H15V5C18.866 5 22 8.13401 22 12V12C22 15.866 18.866 19 15 19V19H14.5M9.5 5H9V5C5.13401 5 2 8.13401 2 12V12C2 15.866 5.13401 19 9 19V19H9.5M8 12H16"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M14.5 5H15C16.3197 5 17.554 5.36518 18.6076 6M14.5 19H15C18.866 19 22 15.866 22 12C22 10.9264 21.7583 9.90926 21.3264 9M9.5 19H9C5.13401 19 2 15.866 2 12C2 8.13401 5.13401 5 9 5H9.5M8 12H16"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M14.5 5H15V5C18.866 5 22 8.13401 22 12V12C22 15.866 18.866 19 15 19V19H14.5M9.5 5H9V5C5.13401 5 2 8.13401 2 12V12C2 15.866 5.13401 19 9 19V19H9.5M8 12H16"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				d="M14.5 5H15V5C18.866 5 22 8.13401 22 12V12C22 15.866 18.866 19 15 19V19H14.5M9.5 5H9V5C5.13401 5 2 8.13401 2 12V12C2 15.866 5.13401 19 9 19V19H9.5M8 12H16"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
]);
